import React from 'react'
import { ColumnType } from 'antd/es/table'
import columns from '../../UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import AntdTooltip from 'UI/Tooltip/Tooltip'
import { InfoCircleOutlined } from '@ant-design/icons'

export const serviceProvidersColumns: ColumnType<any>[] = [
  {
    ...columns[COLUMNS_IDS.profileNames],
    title: (
      <>
        <span>Online Name</span>
        <AntdTooltip title='Names used by entity/individual online' placement='bottom' color='#fff'>
          <InfoCircleOutlined style={{ color: '#B8AFAF', marginLeft: '6px' }} />
        </AntdTooltip>
      </>
    ),
  },
  columns[COLUMNS_IDS.verifiedName],
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.reportStatus],
  columns[COLUMNS_IDS.unreportedRevenue],
  columns[COLUMNS_IDS.reported],
  columns[COLUMNS_IDS.totalRevenue],
  columns[COLUMNS_IDS.ecommerceDocumentedRevenue],
  columns[COLUMNS_IDS.serviceProvidersExactRevenue],
  columns[COLUMNS_IDS.revenueSources],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.activityType],
  columns[COLUMNS_IDS.firstActivity],
  columns[COLUMNS_IDS.caseId],
  columns[COLUMNS_IDS.ecommerceTotalSoldItems],
  columns[COLUMNS_IDS.ecommerceTotalReviews],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  serviceProvidersColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
